import { apiClient, type ApiResponse } from '@/lib/apiClient';
import type { MixpanelEventName } from '@/lib/mixpanel';

export interface TrackAnalyticsEventBody {
  eventName: MixpanelEventName;
  properties?: Record<string, unknown>;
}

export type TrackAnalyticsEventResponse = ApiResponse<{
  success: boolean;
}>;

export const trackAnalyticsEvent = async (data: TrackAnalyticsEventBody): Promise<TrackAnalyticsEventResponse> => {
  const response = await apiClient.post<TrackAnalyticsEventResponse>('/v1/analytics/track', data);
  return response.data;
};
